(function(angular) {
    angular.module('bizPartEngage').service('core.sso.serivce', ssoService);

    ssoService.$inject = ["$http"];

    function ssoService($http) {
        this.SSOCheckIfUserExists = function(ssoKey, ssoToken) {
            return $http.post(siteRootPath + 'api/loginapi/SSOCheckIfUserExists', {SSOKey: ssoKey, SSOToken: ssoToken});
        };

        this.Login = function(ssoKey, ssoToken) {
            return $http.post(siteRootPath + 'api/loginapi/SSO', {SSOKey: ssoKey, SSOToken: ssoToken});
        };

        this.RegisterSSOUser = function(ssoKey, ssoToken, userName, firstName, lastName, email, countryIsoCode) {
            return $http.post(siteRootPath + 'api/loginapi/RegisterSSOUser', 
            {
                SSOKey: ssoKey, 
                SSOToken: ssoToken,
                UserName: userName,
                FirstName: firstName,
                LastName: lastName,
                Email: email,
                CountryIsoCode: countryIsoCode
            });
        };
    }
})(window.angular);
